import { InputContainer, type InputContainerProps } from "@/components/ui/forms/inputContainer"

export type DropdownInputProps = {
  label?: string
  error?: React.JSX.Element
  isRequiredInput?: boolean
  options: { label: string; value: string; disabled?: boolean }[]
  className?: string
  children: React.ReactNode
} & InputContainerProps

export function DropdownInput({
  label,
  error,
  isRequiredInput = false,
  className,
  children,
  ...props
}: DropdownInputProps) {
  return (
    <InputContainer label={label} isRequiredInput={isRequiredInput} error={error} className={className} {...props}>
      {children}
    </InputContainer>
  )
}
